<template>
	<div class="register-step status">
		<div v-if="status === 'waiting'" class="register-status">
			<div class="register-status-image">
				<img src="@/assets/images/icons/waiting.svg" alt="">
			</div>
			<div class="register-status-content">
				<h3>Płatność jest przetwarzana.</h3>
				<p>Czekamy na odpowiedź od operatora płatności, o statusie transakcji.</p>
				<p>Potwierdzenie płatności zwykle trwa kilka minut.
				Możesz spokojnie zamknąć tę stronę. O zmianie statusu płatności poinformujemy Cię w wiadomości
				e-mail.</p>
			</div>
		</div>
		<div v-else-if="status === 'success'" class="register-status">
			<div class="register-status-image">
				<img src="@/assets/images/icons/success.svg" alt="">
			</div>
			<div class="register-status-content">
				<h3 class="text-success">Dziękujemy za opłacenie udziału.</h3>
			</div>
		</div>
		<div v-else-if="status === 'error'" class="register-status">
			<div class="register-status-image">
				<img src="@/assets/images/icons/failed.svg" alt="">
			</div>
			<div class="register-status-content">
				<h3 class="text-error">Coś poszo nie tak i nie udało się zrealizować płatności.</h3>
				<p>Spróbuj dokonać płatności jeszcze raz.</p>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api';

export default {
	name: 'PaymentStatus',
	data() {
        return {
			status: 'waiting'
		}
	},
	created() {
		if (this.$route.query.id) this.getPaymentStatus(this.$route.query.id)
	},
	methods: {
		async getPaymentStatus(id) {
			try {
				const response = await api.get(`/p24/success/${id}`);
				if (response?.status) {
					this.status = response.status
				}
			} catch (e) {
				console.log(e)
				return;
			}
		},
	}
}
</script>

<style scoped>
.register-status {display: flex;justify-content: center;flex-wrap: wrap;}
.register-status-image {width: 267px;margin-right: 30px;text-align: center;}
.register-status-content {width: 360px;}
.register-status-content h3 {margin-bottom: 16px;}
.register-status-content p {font-size: 14px;line-height: 24px;}
.register-status-content p + p {margin-top: 16px;}
.register-status-content b {display: block;font-family: 'Bariol Bold';font-size: 24px;line-height: 32px;}
.register-status-content .btn {margin-top: 32px;margin-bottom: 32px;}
.text-success {color: var(--color-dark-pastel-green)}
.text-error {color: var(--color-pinky-red)}
.text-normal {font-family: 'Open Sans', sans-serif;}

@media (max-width: 992px) {
  .register-step.status { margin-top: 24px;	}
}
@media (min-width: 992px) {
	.register-step.status { margin-top: 64px; }
}
</style>